import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import Flow from "src/components/Flow";

import LullabiesEditor from "../scenes/LullabiesEditor";
import Lullabies from "../scenes/Lullabies";
import LullabiesLibrary from "../scenes/LullabiesLibrary";
import LullabyPlayer from "../scenes/LullabyPlayer";
import { getLullabies, getDefaultLullaby } from "../duck/selectors";

export default React.memo(function LullabiesFlow({ initialStep, ...rest }) {
  const lullabies = useSelector(getLullabies);
  const defaultLullaby = useSelector(getDefaultLullaby);

  const steps = useMemo(
    () => [
      {
        id: "lullabies",
        Component: ({ lullabies, flow, onClose, onBack, initialStep }) => {
          return (
            <Lullabies
              lullabies={lullabies}
              onClose={onClose}
              onBack={
                initialStep === "player"
                  ? () => flow.push("player", { direction: "previous" })
                  : onBack
              }
              openEditor={(lullabieId) =>
                flow.push("editor", { state: { lullabieId } })
              }
              openLibrary={() => flow.push("lullabies-library")}
            />
          );
        }
      },
      {
        id: "lullabies-library",
        Component: ({ lullabies, flow, onClose }) => {
          return (
            <LullabiesLibrary
              lullabies={lullabies}
              onClose={onClose}
              onBack={flow.previous}
            />
          );
        }
      },
      {
        id: "editor",
        Component: ({ onClose, onBack, flow, initialStep, lullabies }) => {
          return (
            <LullabiesEditor
              onClose={onClose}
              onBack={initialStep === "editor" ? onBack : flow.previous}
              originalLullaby={lullabies[flow.state.lullabieId]}
              afterSave={() =>
                flow.push("lullabies", { direction: "previous" })
              }
            />
          );
        }
      },
      {
        id: "player",
        Component: ({
          flow,
          onClose,
          lullabies,
          defaultLullaby,
          lullabyPlayer
        }) => {
          const otherLullabies = useMemo(
            () =>
              Object.values(lullabies).filter(
                (lullaby) => lullaby.objectId !== defaultLullaby.objectId
              ),
            [lullabies, defaultLullaby]
          );
          return (
            <LullabyPlayer
              lullabyPlayer={lullabyPlayer}
              onClose={onClose}
              otherLullabies={otherLullabies}
              defaultLullaby={defaultLullaby}
              openLullabies={() => flow.push("lullabies")}
            />
          );
        }
      }
    ],
    []
  );

  return (
    <Flow
      lullabies={lullabies}
      defaultLullaby={defaultLullaby}
      initialStep={initialStep}
      steps={steps}
      {...rest}
    />
  );
});
